import { ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, RegisterOptions } from 'react-hook-form';

type FormSelectProps = {
	name: string;
	type?: 'select';
	id?: string;
	className?: string;
	containerClass?: string;
	label?: string;
	placeholder?: string;
	helpText?: string;
	multiple?: boolean;
	children: ReactNode;
	errors?: any;
	control?: Control<any>;
	register?: RegisterOptions;
	onChangeCustom?: (e: any) => void;
	disabled?: boolean;
	selectedValue?: string;
};

const SelectInput = ({
	name,
	type = 'select',
	id,
	className,
	containerClass,
	label,
	placeholder,
	helpText,
	children,
	multiple,
	errors,
	control,
	register,
	onChangeCustom = () => {},
	selectedValue,
	disabled,
	...props
}: FormSelectProps) => {
	const hasError = (errors && errors[name]) != null;
	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState }) => (
				<Form.Group className={containerClass ?? ''}>
					{label && <Form.Label>{label}</Form.Label>}
					<Form.Select
						multiple={multiple}
						id={id}
						disabled={disabled}
						{...props}
						{...field}
						value={selectedValue ?? field.value ?? ''}
						onChange={(e) => {
							field.onChange(e.target.value);
							onChangeCustom(e.target.value);
						}}
						className={className}
						isInvalid={fieldState.error?.message != null || hasError}
					>
						{children}
					</Form.Select>
					{helpText && (
						<Form.Text id={`${name}-help`} muted>
							{helpText}
						</Form.Text>
					)}
					{fieldState.error?.message && (
						<Form.Control.Feedback type="invalid">
							{fieldState.error?.message}
						</Form.Control.Feedback>
					)}
					{hasError && (
						<Form.Control.Feedback type="invalid">
							{typeof errors[name] === 'string' && errors[name]}
							{errors[name]?.message}
							{errors[name] &&
								Array.isArray(errors[name]) &&
								errors[name].map((message: string) => message)}
						</Form.Control.Feedback>
					)}
				</Form.Group>
			)}
		/>
	);
};

export default SelectInput;
